/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Sociology14Inputs */

const en__field_enum_study_sociology14 = /** @type {(inputs: _Field_Enum_Study_Sociology14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sociology`)
};

const de__field_enum_study_sociology14 = /** @type {(inputs: _Field_Enum_Study_Sociology14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soziologie`)
};

/**
* | output |
* | --- |
* | "Sociology" |
*
* @param {_Field_Enum_Study_Sociology14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_sociology14 = /** @type {((inputs?: _Field_Enum_Study_Sociology14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Sociology14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_sociology14(inputs)
	return de__field_enum_study_sociology14(inputs)
});
export { _field_enum_study_sociology14 as "_field_enum_STUDY_SOCIOLOGY" }